import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Facebook, MessageCircle, ArrowRight } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-cream" data-id="element-30">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-32">
          <span className="text-gold text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-33">
            Get in Touch
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal mb-6" data-id="element-34">
            Let's Create Something Beautiful
          </h2>
          <p className="text-charcoal/70 font-light leading-relaxed mb-12 max-w-lg mx-auto" data-id="element-35">
            Whether you're planning a family session, looking for newborn
            photos, or just want to say hello — I'd love to hear from you!
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-16" data-id="element-36">
            <a href="https://www.facebook.com/photosbytunga" target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 bg-charcoal text-white px-8 py-4 rounded-full hover:bg-gold transition-colors duration-300" data-id="element-37">
              <Facebook className="w-5 h-5" data-id="element-38" />
              <span className="tracking-wide text-sm font-medium" data-id="element-39">
                Message on Facebook
              </span>
              <ArrowRight className="w-4 h-4 opacity-0 -ml-2 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-40" />
            </a>
            <a href="sms:8288380629" className="group flex items-center gap-3 bg-white border border-charcoal/20 text-charcoal px-8 py-4 rounded-full hover:border-gold hover:text-gold transition-all duration-300" data-id="element-41">
              <MessageCircle className="w-5 h-5" data-id="element-42" />
              <span className="tracking-wide text-sm font-medium" data-id="element-43">
                Text (828) 838-0629
              </span>
            </a>
          </div>

          <div className="flex items-center justify-center gap-3 text-charcoal/60" data-id="element-44">
            <MapPin className="w-4 h-4 text-gold" data-id="element-45" />
            <span className="font-light text-sm tracking-wide" data-id="element-46">
              Shenandoah Valley, Virginia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}